import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { Produto } from 'src/app/model/produto';

@Component({
  selector: 'app-ordenar-produtos',
  templateUrl: './ordenar-produtos.page.html',
  styleUrls: ['./ordenar-produtos.page.scss'],
})
export class OrdenarProdutosPage implements OnInit {
  produtos: Produto[];

  produto: Produto;

  cols: any[];

  teste;

  constructor(private route: ActivatedRoute, private produtoapiService: ProdutoapiService, private toast: ToastService) { }

  ngOnInit() {

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      //this.title = 'Cadastro de Produto';
      // tslint:disable-next-line: radix
    }

    //this.produtos = this.produtoapiService.GetByCat(parseInt(idParam))
    this.produtoapiService.GetByCat(parseInt(idParam)).then(data => this.produtos = data);
      this.cols = [
          { field: 'nome', header: 'Name' },
          { field: 'ativo', header: 'Ativo' },
      ];
    }

  async onSubmit(){
  for (let index = 0; index < this.produtos.length; index++) {
    const element = this.produtos[index];

    element.posicao = index;
    const result = await this.produtoapiService.atualizar(element);
    //this.categoria.id = result.id;
    this.toast.showSucess('Produtos Ordenados com Sucesso!');
    
    
  }
  }

}